<template>
  <div class="error-page">
    <div class="error-container">
      <h1 class="error-title font-rubik">
        {{ error.statusCode }}
      </h1>
      <p class="section-title">
        {{ error?.message || error?.statusMessage || 'Oops! Something went wrong' }}
      </p>
      <AppBtn
        v-if="isButtonVisible"
        width="164"
        rounded="30"
        class="purple-btn mt-5"
        @click="clearError({ redirect: '/' })"
      >
        <span>
          Go Home
        </span>
      </AppBtn>
    </div>
    <div class="galaxy bg-image galaxy-rotation" />
    <ClientOnly>
      <AppBackground />
    </ClientOnly>
  </div>
</template>

<script>
export default {
  setup () {
    const error = useError();

    return { error };
  },
  computed: {
    isButtonVisible () {
      return this.$route.path !== '/' && this.error.statusCode < 500;
    },
  }
}
</script>

<style lang="scss" scoped>
.error-page {
  overflow: hidden;
  position: relative;

  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    overflow: hidden;
    position: relative; 

    .error-title {
      color: white;
      font-size: 256px;
      line-height: 100%;
    }

    .section-title {
      margin-bottom: 20px;
    }
  }
}

@media only screen and (max-width: $sm) {
  .error-page {
    .error-container {
      .error-title {
        font-size: 100px;
      }

      .section-title {
        font-size: 24px;
      }
    }
  }
}
</style>